import * as code from "../constants/codes";

export const editorKeyMap = {
  OPEN_GLOBAL_SEARCH: [
    `${code.COMMAND}+${code.KEY_K}`,
    `${code.CONTROL}+${code.KEY_K}`,
  ],
  UNDO: [`${code.COMMAND}+${code.KEY_Z}`, `${code.CONTROL}+${code.KEY_Z}`],
  REDO: [`${code.COMMAND}+${code.KEY_Y}`, `${code.CONTROL}+${code.KEY_Y}`],
  EXPORT_AS_JPEG: [
    `${code.COMMAND}+${code.SHIFT}+${code.KEY_E}`,
    `${code.CONTROL}+${code.SHIFT}+${code.KEY_E}`,
  ],
  OPEN_TEXT_PANEL: code.KEY_T,
  OPEN_ASSETS_PANEL: code.KEY_A,
  OPEN_VISUALS_PANEL: code.KEY_V,
  OPEN_MEDIA_PANEL: code.KEY_M,
  OPEN_HOTKEYS_PANEL: [
    `${code.COMMAND}+${code.FORWARD_SLASH}`,
    `${code.CONTROL}+${code.FORWARD_SLASH}`,
  ],
  CLOSE_PANEL: code.ESCAPE,
  ZOOM_IN: code.EQUAL,
  ZOOM_OUT: code.MINUS,
  ZOOM_ONE_TO_ONE: code.KEY_O,
  ZOOM_TO_FIT: code.KEY_P,
  GRAB_MODE: {
    sequence: `${code.SPACE}`,
    action: "keydown",
  },
  SELECTION_MODE: {
    sequence: `${code.SPACE}`,
    action: "keyup",
  },
  CLONE: [`${code.COMMAND}+${code.KEY_D}`, `${code.CONTROL}+${code.KEY_D}`],
  DELETE: [`${code.DELETE}`, `${code.BACKSPACE}`],
  MOVE_LAYER_ONE_UNIT: [
    `${code.ARROW_LEFT}`,
    `${code.ARROW_UP}`,
    `${code.ARROW_RIGHT}`,
    `${code.ARROW_DOWN}`,
  ],
  MOVE_LAYER_TEN_UNITS: [
    `${code.SHIFT}+${code.ARROW_LEFT}`,
    `${code.SHIFT}+${code.ARROW_UP}`,
    `${code.SHIFT}+${code.ARROW_RIGHT}`,
    `${code.SHIFT}+${code.ARROW_DOWN}`,
  ],
  MOVE_LAYER_HUNDRED_UNITS: [
    `${code.COMMAND}+${code.ARROW_LEFT}`,
    `${code.COMMAND}+${code.ARROW_UP}`,
    `${code.COMMAND}+${code.ARROW_RIGHT}`,
    `${code.COMMAND}+${code.ARROW_DOWN}`,
    `${code.CONTROL}+${code.ARROW_LEFT}`,
    `${code.CONTROL}+${code.ARROW_UP}`,
    `${code.CONTROL}+${code.ARROW_RIGHT}`,
    `${code.CONTROL}+${code.ARROW_DOWN}`,
  ],
  ARTBOARD_PREV: code.ARROW_LEFT,
  ARTBOARD_NEXT: code.ARROW_RIGHT,
  COPY: [`${code.COMMAND}+${code.KEY_C}`, `${code.CONTROL}+${code.KEY_C}`],
  PASTE: [`${code.COMMAND}+${code.KEY_V}`, `${code.CONTROL}+${code.KEY_V}`],
  LOCK: [
    `${code.COMMAND}+${code.SHIFT}+${code.KEY_L}`,
    `${code.CONTROL}+${code.SHIFT}+${code.KEY_L}`,
  ],
  GROUP: [`${code.COMMAND}+${code.KEY_G}`, `${code.CONTROL}+${code.KEY_G}`],
  UNGROUP: [
    `${code.COMMAND}+${code.SHIFT}+${code.KEY_G}`,
    `${code.CONTROL}+${code.SHIFT}+${code.KEY_G}`,
  ],
  SELECT_TOP_LAYER: [`${code.ALT}+${code.PERIOD}`],
  SELECT_BOTTOM_LAYER: [`${code.ALT}+${code.COMMA}`],
  BOLD: [`${code.COMMAND}+${code.KEY_B}`, `${code.CONTROL}+${code.KEY_B}`],
  ITALIC: [`${code.COMMAND}+${code.KEY_I}`, `${code.CONTROL}+${code.KEY_I}`],
  UNDERLINE: [`${code.COMMAND}+${code.KEY_U}`, `${code.CONTROL}+${code.KEY_U}`],
  STRIKETHROUGH: [
    `${code.COMMAND}+${code.SHIFT}+${code.KEY_X}`,
    `${code.CONTROL}+${code.SHIFT}+${code.KEY_X}`,
  ],
  SELECT_ALL_LAYERS: [
    `${code.COMMAND}+${code.KEY_A}`, `${code.CONTROL}+${code.KEY_A}`
  ],
  CUT: [
    `${code.COMMAND}+${code.KEY_X}`, `${code.CONTROL}+${code.KEY_X}`
  ],
  BRING_TO_FRONT: [`${code.CONTROL}+${code.SHIFT}+${code.BRACKET_RIGHT}`],
  BRING_FORWARD: [
    `${code.COMMAND}+${code.BRACKET_RIGHT}`,
    `${code.CONTROL}+${code.BRACKET_RIGHT}`
  ],
  SEND_BACKWARD: [
    `${code.COMMAND}+${code.BRACKET_LEFT}`,
    `${code.CONTROL}+${code.BRACKET_LEFT}`
  ],
  SEND_TO_BACK: [`${code.CONTROL}+${code.SHIFT}+${code.BRACKET_LEFT}`],
};
